import { render, staticRenderFns } from "./insertTemplate.vue?vue&type=template&id=5b0ed4ec&"
import script from "./insertTemplate.vue?vue&type=script&lang=js&"
export * from "./insertTemplate.vue?vue&type=script&lang=js&"
import style0 from "./insertTemplate.vue?vue&type=style&index=0&id=5b0ed4ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports